import React, { useState } from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import AliasTypeFilter from '../Filter/AliasTypeFilter'

const AliasTypeSearchField = ({ ordersStore, handleChange }) => {
  const [aliasType, setAliasType] = useState({
    aliasTypeId: ordersStore.aliasTypeId,
  })
  const updateAliasType = (newObj) => {
    setAliasType({ aliasTypeId: newObj.aliasTypeId })
    handleChange('aliasTypeId', newObj ? newObj.aliasTypeId : null)
  }

  return (
    <>
      <AliasTypeFilter
        aliasTypeFilter={aliasType}
        setAliasTypeFilter={updateAliasType}
        defaultOptionIsSelectable={true}
      />
    </>
  )
}

export default withTranslation()(
  inject('ordersStore')(observer(AliasTypeSearchField))
)
